import LogoPNG from "../../assets/Logo_Laranja.svg";

const Logo = (props) => {
  return <img width={props.width || 120} src={props.src || LogoPNG}></img>;
};

export default Logo;
